import { render } from "./AntibotVerification.vue?vue&type=template&id=7cce5f03&scoped=true"
import script from "./AntibotVerification.vue?vue&type=script&lang=js"
export * from "./AntibotVerification.vue?vue&type=script&lang=js"

import "./AntibotVerification.vue?vue&type=style&index=0&id=7cce5f03&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cce5f03"]])

export default __exports__